import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TAttachmentsStore,
	TAttachmentTypesResponsePayload,
	TEmAttachmentsListResponsePayload,
	TGenerateUploadLinkResponsePayload,
} from './types';

export const getAttachmentsState = (state: TStoreState): TAttachmentsStore => state.attachments;

export const getAttachmentTypes = createSelector(
	getAttachmentsState,
	(state: TAttachmentsStore): TAttachmentTypesResponsePayload => state.attachmentTypes,
);
export const getAttachmentTypesLoading = createSelector(
	getAttachmentsState,
	(state: TAttachmentsStore): boolean => state.attachmentTypesLoading,
);

export const getEmAttachments = createSelector(
	getAttachmentsState,
	(state: TAttachmentsStore): TEmAttachmentsListResponsePayload => state.emAttachments,
);
export const getEmAttachmentsLoading = createSelector(
	getAttachmentsState,
	(state: TAttachmentsStore): boolean => state.emAttachmentsLoading,
);

export const getEmAttachmentUploadLoading = createSelector(
	getAttachmentsState,
	(state: TAttachmentsStore): boolean => state.uploadLoading,
);
export const getEmAttachmentDownloadLoading = createSelector(
	getAttachmentsState,
	(state: TAttachmentsStore): boolean => state.downloadLoading,
);
export const getEmAttachmentDeleteLoading = createSelector(
	getAttachmentsState,
	(state: TAttachmentsStore): boolean => state.deleteLoading,
);

export const getGenerateUploadLinkLoading = createSelector(
	getAttachmentsState,
	(state: TAttachmentsStore): boolean => state.generateUploadLinkLoading,
);

export const getGenerateUploadLinkResult = createSelector(
	getAttachmentsState,
	(state: TAttachmentsStore): TGenerateUploadLinkResponsePayload =>
		state.generateUploadLinkResult,
);
